import { AffiliateFilter } from '@/components/filters/AffiliateFilter';
import { DateRangeFilter } from '@/components/filters/DateRangeFilter';
import { StatusFilter } from '@/components/filters/StatusFilter';
import { FilterGroup } from '@/components/filters/filter-button';
import { HStack } from '@chakra-ui/react';
import React from 'react';

export const CommissionHistoryFilters: React.FC = () => {
  return (
    <FilterGroup>
      <HStack gap={3} alignItems="flex-start" wrap="wrap">
        <AffiliateFilter />
        <StatusFilter />
        <DateRangeFilter />
      </HStack>
    </FilterGroup>
  );
};
